import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

// import { motion as m } from 'framer-motion';

import Header from './components/Header';
import AnimatedRoutes from './components/AnimatedRoutes';

// import { CursorContext } from './context/CursorContext';

function App() {
  // const { cursorVariants, cursorBG } = useContext(CursorContext);

  return (
    <>
      <Router>
        <Header />
        <AnimatedRoutes />
      </Router>
      {/* <m.div
        variants={cursorVariants}
        animate={cursorBG}
        className='
          fixed top-0 left-0 z-50
          w-8 h-8
          pointer-events-none
          rounded-full
          bg-secondary
        '>
        </m.div> */}
    </>
  );
}

export default App;
